import axios from 'api/axios'

export const uploadFile = async (file, tipo_documento, tipo_expediente, id_proceso) => {
  try {
    const formData = new FormData()
    formData.append('fichero', file)
    formData.append('nombre', file.name)
    formData.append('tipo_documento', tipo_documento)
    formData.append('tipo_expediente', tipo_expediente)

    if (id_proceso) {
      formData.append('id_proceso', id_proceso)
    }

    const response = await axios.post('/ficherosexpedientes/subir_fichero/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    // Error handled
  }
}

export const downloadFile = async (token, visor = 'N') => {
  try {
    const body = {
      token: token,
      visor: visor,
    }
    const response = await axios
      .post(`/expedienteslisa/getFicheroExpediente/`, body)
      .then((response) => {
        return response.data
      })

    return response
  } catch (error) {
    // Error handled
  }
}

export const blobDownload = (blobString, mimeType, fileName) => {
  const binary = window.atob(blobString.replace(/\s/g, ''))
  const len = binary.length
  const buffer = new ArrayBuffer(len)
  const view = new Uint8Array(buffer)

  for (let i = 0; i < len; i += 1) {
    view[i] = binary.charCodeAt(i)
  }

  const blobFile = new Blob([view], { type: mimeType })
  const url = URL.createObjectURL(blobFile)

  const a = document.createElement('a')
  document.body.appendChild(a)
  a.style.display = 'none'
  a.href = url
  a.download = fileName

  a.click()
}

export const asociateFiles = async (tipo_expediente, numero_expediente, id_proceso) => {
  try {
    const body = {
      tipo_expediente: tipo_expediente,
      numero_expediente: numero_expediente,
      id_proceso: id_proceso,
    }

    await axios.post('/ficherosexpedientes/asociar_ficheros_expediente/', body)
  } catch (error) {
    // Error handled
  }
}

export const deletePostedFile = async (id_proceso, id_documento) => {
  try {
    const body = {
      id_proceso: id_proceso,
      id_documento: id_documento,
    }

    const response = await axios.delete('/ficherosexpedientes/eliminar_fichero_cargado/', {
      data: body,
    })

    return response.data
  } catch (error) {
    // Error handled
  }
}
